'use client';
import React, { useEffect, useState } from 'react';
import FlipUnit from './FlipUnit';

const TimerClock = ({ endTime }) => {
  const getTimeLeft = () => {
    const now = new Date();
    const target = new Date(endTime + "+05:30");
    const diff = Math.max(0, Math.floor((target - now) / 1000));
    const hrs = Math.floor(diff / 3600);
    const mins = Math.floor((diff % 3600) / 60);
    const secs = diff % 60;
    return {
      hrs: String(hrs).padStart(2, '0'),
      mins: String(mins).padStart(2, '0'),
      secs: String(secs).padStart(2, '0'),
    };
  };

  const [time, setTime] = useState(getTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getTimeLeft());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hidden lg:flex items-center gap-2 rounded">
      <FlipUnit value={time.hrs[0]} />
      <FlipUnit value={time.hrs[1]} />
      <div className="text-white text-2xl">:</div>
      <FlipUnit value={time.mins[0]} />
      <FlipUnit value={time.mins[1]} />
      <div className="text-white text-2xl">:</div>
      <FlipUnit value={time.secs[0]} />
      <FlipUnit value={time.secs[1]} />
    </div>
  );
};

export default TimerClock;
